// Seed data: 48 BCS Units across the deaneries of the Archdiocese of Bombay.
// Used as a graceful fallback until the Supabase tables are created & seeded.

const IMAGES = [
  "https://images.unsplash.com/photo-1438232992991-995b7058bbb3?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1511632765486-a01980e01a18?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1595658658481-d53d3f999875?auto=format&fit=crop&w=1200&q=70",
];

const BASE_UNITS = [
  // [name, deanery, area]
  ["Cathedral of the Holy Name", "South Mumbai", "Colaba"],
  ["Our Lady of Health", "South Mumbai", "Cavel"],
  ["St. Francis Xavier", "South Mumbai", "Dabul"],
  ["Holy Rosary Church", "South Mumbai", "Mazagaon"],
  ["Gloria Church", "Byculla", "Byculla"],
  ["St. Anne's Church", "Byculla", "Mazagaon"],
  ["St. Ignatius Church", "Byculla", "Jacob Circle"],
  ["Our Lady of Dolours", "Wadala", "Wadala"],
  ["St. Joseph's Church", "Wadala", "Wadala East"],
  ["Salvation Church", "Mahim-Dadar", "Dadar"],
  ["St. Michael's Church", "Mahim-Dadar", "Mahim"],
  ["Our Lady of Victories", "Mahim-Dadar", "Mahim"],
  ["St. Paul's Church", "Mahim-Dadar", "Dadar East"],
  ["St. Peter's Church", "Bandra", "Bandra West"],
  ["Mount Carmel Church", "Bandra", "Bandra West"],
  ["St. Andrew's Church", "Bandra", "Bandra West"],
  ["St. Theresa's Church", "Bandra", "Bandra West"],
  ["St. Anne's Church Bandra", "Bandra", "Pali Hill"],
  ["Our Lady of Mount Carmel", "Bandra", "Khar"],
  ["Sacred Heart Church", "Santacruz-Juhu", "Santacruz West"],
  ["St. Anthony's Church", "Santacruz-Juhu", "Vakola"],
  ["Our Lady of Egypt", "Santacruz-Juhu", "Kalina"],
  ["St. Joseph's Church Juhu", "Santacruz-Juhu", "Juhu"],
  ["St. Blaise Church", "Andheri", "Amboli"],
  ["Holy Family Church", "Andheri", "Andheri East"],
  ["San Lorenzo Church", "Andheri", "Four Bungalows"],
  ["Infant Jesus Church", "Andheri", "Jogeshwari"],
  ["St. John the Evangelist", "Andheri", "Marol"],
  ["Our Lady of Lourdes", "Malad", "Orlem"],
  ["St. Anthony's Church Malwani", "Malad", "Malwani"],
  ["Our Lady of the Forsaken", "Malad", "Marve"],
  ["St. Jude Church", "Malad", "Malad East"],
  ["Immaculate Conception Church", "Borivali", "Borivali West"],
  ["St. Francis D'Assisi Church", "Borivali", "Mount Poinsur"],
  ["Our Lady of Assumption", "Borivali", "Kandivali"],
  ["St. Lawrence Church", "Borivali", "Kandivali East"],
  ["Mary Immaculate Church", "Borivali", "Dahisar"],
  ["Our Lady of Nazareth", "Bhayandar", "Bhayandar West"],
  ["Holy Cross Church", "Kurla", "Kurla West"],
  ["St. Anthony's Church Vidyavihar", "Kurla", "Vidyavihar"],
  ["Our Lady of Perpetual Succour", "Chembur", "Chembur"],
  ["St. Anthony's Church Trombay", "Chembur", "Trombay"],
  ["St. Francis Xavier Church Vikhroli", "Bhandup-Mulund", "Vikhroli"],
  ["St. Pius X Church", "Bhandup-Mulund", "Mulund"],
  ["St. John the Baptist Church", "Thane", "Thane West"],
  ["Our Lady of Mercy Church", "Thane", "Kalwa"],
  ["Sacred Heart Church Vashi", "Navi Mumbai", "Vashi"],
  ["St. Joseph the Worker Church", "Navi Mumbai", "Nerul"],
];

function slugOf(name) {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

export const seedUnits = BASE_UNITS.map(([name, deanery, area], i) => ({
  id: `seed-unit-${i + 1}`,
  slug: slugOf(name),
  name: `BCS Unit – ${name}`,
  parish_name: name,
  deanery,
  area,
  address: `${name}, ${area}, Mumbai, Maharashtra`,
  president: null,
  contact_phone: null,
  contact_email: null,
  description: `The ${name} unit of The Bombay Catholic Sabha serves the parish community of ${area}. The unit organises civic awareness drives, social outreach, environment initiatives and youth training programmes in coordination with the parish and the Sabha's three forums.`,
  image_url: IMAGES[i % IMAGES.length],
  established_year: 1972 + (i % 40),
  member_count: 350 + ((i * 137) % 1800),
  is_published: true,
  is_featured: i % 12 === 0,
  sort_order: i + 1,
}));

export const seedUnitPosts = [
  {
    id: "seed-up-1",
    unit_slug: "st-peter-s-church",
    title: "Voter registration drive completed at St. Peter's",
    body: "Over 240 new voters were registered during the Sunday drive organised by the unit in coordination with the Socio Civic & Political Forum.",
    post_type: "update",
    image_url: IMAGES[2],
    created_at: "2026-04-12",
    is_published: true,
  },
  {
    id: "seed-up-2",
    unit_slug: "immaculate-conception-church",
    title: "Parish composting project enters second phase",
    body: "The unit's green cell expanded its wet-waste composting initiative to 4 housing societies around the parish, diverting nearly 200 kg of waste weekly.",
    post_type: "update",
    image_url: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?auto=format&fit=crop&w=1200&q=70",
    created_at: "2026-03-28",
    is_published: true,
  },
  {
    id: "seed-up-3",
    unit_slug: "our-lady-of-lourdes",
    title: "Career guidance session for SSC students",
    body: "The Orlem unit hosted a Youth & Training Forum career guidance session attended by 120 students and parents.",
    post_type: "update",
    image_url: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?auto=format&fit=crop&w=1200&q=70",
    created_at: "2026-02-15",
    is_published: true,
  },
];
